export const GOOGLE_TAG_MANAGER = {
  CONTAINER_ID: 'GTM-NPVLW5T'
};
